import React from 'react';
import {Skeleton} from '@mui/material';
import './index.scss';

const SKELETON_TEXT_WIDTH = 140;
const SKELETON_HEADER_WIDTH = 200;
const SKELETON_HEADER_HEIGHT = 64;

const BuyupOrderDetailsCardSkeleton: React.FC = () => {
  return (
    <div className="buyupOrderDetailsCard">
      <div className="orderNumber">
        <Skeleton
          width={SKELETON_HEADER_WIDTH}
          height={SKELETON_HEADER_HEIGHT}
        />
      </div>
      <div className="buyupOrderDetailsCard-summary">
        <div className="summaryItem">
          <Skeleton width={SKELETON_TEXT_WIDTH} />
          <Skeleton width={SKELETON_TEXT_WIDTH} />
        </div>
        <div className="summaryItem">
          <Skeleton width={SKELETON_TEXT_WIDTH} />
          <Skeleton width={SKELETON_TEXT_WIDTH} />
        </div>
        <div className="summaryItem">
          <Skeleton width={SKELETON_TEXT_WIDTH} />
          <Skeleton width={SKELETON_TEXT_WIDTH} />
        </div>
        <div className="summaryItem">
          <Skeleton width={SKELETON_TEXT_WIDTH} />
          <Skeleton width={SKELETON_TEXT_WIDTH} />
        </div>
      </div>
      <div className="buyupOrderDetailsCard-creditCard">
        <div className="creditCardItem">
          <Skeleton width={SKELETON_TEXT_WIDTH} />
        </div>
        <div>
          <Skeleton width="100%" height={SKELETON_HEADER_HEIGHT} />
          <Skeleton width="100%" height={SKELETON_HEADER_HEIGHT} />
        </div>
      </div>
    </div>
  );
};

export default BuyupOrderDetailsCardSkeleton;
